import { render } from "./AddTailleModal.vue?vue&type=template&id=3c774690&ts=true"
import script from "./AddTailleModal.vue?vue&type=script&lang=ts"
export * from "./AddTailleModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__